"use client";
import {
  useMenuContext
} from "../__chunks/YGMEBI3A.js";
import "../__chunks/KA4GX64Z.js";
import {
  useCompositeSeparator
} from "../__chunks/ENRQQ6LK.js";
import "../__chunks/YZEJGRDQ.js";
import "../__chunks/IB7YUKH5.js";
import "../__chunks/4UUKJZ4V.js";
import "../__chunks/TI7CMBHW.js";
import "../__chunks/7H5KSHHF.js";
import "../__chunks/G6BJYYBK.js";
import "../__chunks/OAYFXAQ2.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/3ORBWXWF.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/menu/menu-separator.ts
var useMenuSeparator = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useMenuContext();
    store = store || context;
    props = useCompositeSeparator(__spreadValues({ store }, props));
    return props;
  }
);
var MenuSeparator = createComponent((props) => {
  const htmlProps = useMenuSeparator(props);
  return createElement("hr", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  MenuSeparator.displayName = "MenuSeparator";
}
export {
  MenuSeparator,
  useMenuSeparator
};
